/* ============================================================
   Evida — runtime do tema (substitui o React/DCLogic do preview)
   Vanilla JS, sem dependências. Cada módulo se liga por data-*
   e é idempotente, para funcionar no editor de temas do Shopify
   (onde seções são re-renderizadas via shopify:section:load).
   ============================================================ */
(function () {
  'use strict';

  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var raf = window.requestAnimationFrame.bind(window);

  /* ---------------------------------------------------------
     1. CARRINHO — Shopify Cart AJAX API
     --------------------------------------------------------- */
  var Cart = {
    state: null,

    routes: function () {
      var r = (window.Shopify && window.Shopify.routes) || {};
      return {
        add: (r.root || '/') + 'cart/add.js',
        change: (r.root || '/') + 'cart/change.js',
        get: (r.root || '/') + 'cart.js'
      };
    },

    fetchJSON: function (url, body) {
      // o header marca a chamada como nossa, para o initCartSync abaixo não
      // recarregar o drawer de novo em cima do load que já vem a seguir
      var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Evida-Cart': 'interno' } };
      if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
      return fetch(url, opts).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      });
    },

    load: function () {
      var self = this;
      return this.fetchJSON(this.routes().get).then(function (cart) {
        self.state = cart;
        self.render();
        return cart;
      });
    },

    add: function (variantId, qty, sellingPlan) {
      var self = this;
      var payload = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
      if (sellingPlan) payload.items[0].selling_plan = Number(sellingPlan);
      this.setBusy(true);
      return this.fetchJSON(this.routes().add, payload)
        .then(function () { return self.load(); })
        .then(function () { self.open(); self.setBusy(false); })
        .catch(function (err) {
          self.setBusy(false);
          self.showError((err && err.description) || 'Não foi possível adicionar ao carrinho.');
        });
    },

    change: function (key, qty) {
      var self = this;
      this.setBusy(true);
      return this.fetchJSON(this.routes().change, { id: key, quantity: qty })
        .then(function (cart) { self.state = cart; self.render(); self.setBusy(false); })
        .catch(function () { self.setBusy(false); });
    },

    setBusy: function (busy) {
      var drawer = $('[data-ev-cart]');
      if (drawer) drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
    },

    showError: function (msg) {
      var box = $('[data-ev-cart-error]');
      if (!box) { console.warn(msg); return; }
      box.textContent = msg;
      box.hidden = false;
      setTimeout(function () { box.hidden = true; }, 5000);
    },

    open: function () {
      var d = $('[data-ev-cart]');
      if (!d) return;
      d.hidden = false;
      document.body.style.overflow = 'hidden';
      raf(function () {
        d.setAttribute('data-open', 'true');
        var close = $('[data-ev-cart-close]', d);
        if (close) close.focus();
      });
    },

    close: function () {
      var d = $('[data-ev-cart]');
      if (!d) return;
      d.removeAttribute('data-open');
      document.body.style.overflow = '';
      setTimeout(function () { d.hidden = true; }, 320);
    },

    render: function () {
      var cart = this.state;
      if (!cart) return;

      $$('[data-ev-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      $$('[data-ev-cart-bubble]').forEach(function (el) {
        el.hidden = cart.item_count === 0;
      });

      var list = $('[data-ev-cart-items]');
      var empty = $('[data-ev-cart-empty]');
      var footer = $('[data-ev-cart-footer]');
      if (!list) return;

      if (!cart.items.length) {
        list.innerHTML = '';
        if (empty) empty.hidden = false;
        if (footer) footer.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      if (footer) footer.hidden = false;

      list.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2')
          : '';
        var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<div class="ev-cart-item__variant">' + item.variant_title + '</div>' : '';
        return (
          '<li class="ev-cart-item">' +
            (img ? '<img class="ev-cart-item__img" src="' + img + '" alt="" width="72" height="72" loading="lazy">' : '') +
            '<div class="ev-cart-item__body">' +
              '<a class="ev-cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
              variantLabel +
              '<div class="ev-cart-item__price">' + money(item.final_line_price) + '</div>' +
              '<div class="ev-cart-item__qty">' +
                '<button type="button" data-ev-qty="' + item.key + '" data-ev-qty-delta="-1" aria-label="Diminuir quantidade">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-ev-qty="' + item.key + '" data-ev-qty-delta="1" aria-label="Aumentar quantidade">+</button>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="ev-cart-item__remove" data-ev-remove="' + item.key + '" aria-label="Remover ' + item.product_title + '">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
            '</button>' +
          '</li>'
        );
      }).join('');

      var total = $('[data-ev-cart-total]');
      if (total) total.textContent = money(cart.total_price);
    },

    init: function () {
      var self = this;
      if (this._bound) return;
      this._bound = true;

      document.addEventListener('click', function (e) {
        var t = e.target;

        var opener = t.closest && t.closest('[data-ev-cart-open]');
        if (opener) { e.preventDefault(); self.open(); return; }

        if (t.closest && (t.closest('[data-ev-cart-close]') || t.closest('[data-ev-cart-overlay]'))) {
          e.preventDefault(); self.close(); return;
        }

        var addBtn = t.closest && t.closest('[data-ev-add]');
        if (addBtn) {
          e.preventDefault();
          var vid = addBtn.getAttribute('data-ev-add');
          if (!vid) { self.showError('Produto sem variante selecionada.'); return; }
          self.add(vid, Number(addBtn.getAttribute('data-ev-qty-value') || 1), addBtn.getAttribute('data-ev-selling-plan'));
          return;
        }

        var qtyBtn = t.closest && t.closest('[data-ev-qty]');
        if (qtyBtn) {
          var key = qtyBtn.getAttribute('data-ev-qty');
          var delta = Number(qtyBtn.getAttribute('data-ev-qty-delta'));
          var item = (self.state.items || []).filter(function (i) { return i.key === key; })[0];
          if (item) self.change(key, Math.max(0, item.quantity + delta));
          return;
        }

        var rmBtn = t.closest && t.closest('[data-ev-remove]');
        if (rmBtn) { self.change(rmBtn.getAttribute('data-ev-remove'), 0); return; }
      });

      on(document, 'keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      // formulários de produto (PDP) → add via AJAX
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form.matches || !form.matches('[data-ev-product-form]')) return;
        e.preventDefault();
        var id = form.querySelector('[name="id"]');
        var qty = form.querySelector('[name="quantity"]');
        if (!id || !id.value) { self.showError('Selecione uma opção antes de adicionar.'); return; }
        self.add(id.value, qty ? Number(qty.value) : 1, (form.querySelector('[name="selling_plan"]') || {}).value);
      });

      this.load();
    }
  };
  window.EvidaCart = Cart;

  /* ---------------------------------------------------------
     1b. CARRINHO — sincronia com apps externos

     Apps de upsell (SellEasy e afins) adicionam item chamando
     /cart/add.js por conta própria. O drawer do tema não é o `cart-drawer`
     padrão do Dawn, então o app não sabe atualizá-lo: o cliente via
     "adicionado" e o subtotal continuava o antigo até recarregar a página.

     Aqui envolvemos fetch e XHR para detectar qualquer mutação de carrinho
     feita de fora e recarregar o estado. As chamadas do próprio tema vão
     marcadas com o header X-Evida-Cart e são ignoradas, porque elas já
     chamam load() em seguida.
     --------------------------------------------------------- */
  function initCartSync() {
    if (window.__evCartSyncBound) return;
    window.__evCartSyncBound = true;

    var MUTA = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var timer = null;

    function agendarRefresh() {
      clearTimeout(timer);
      timer = setTimeout(function () { Cart.load(); }, 200);
    }

    function ehInterno(input, init) {
      try {
        var h = (init && init.headers) || (input && input.headers);
        if (!h) return false;
        if (typeof h.get === 'function') return h.get('X-Evida-Cart') === 'interno';
        return h['X-Evida-Cart'] === 'interno';
      } catch (e) { return false; }
    }

    if (window.fetch) {
      var fetchOriginal = window.fetch;
      window.fetch = function (input, init) {
        var url = '';
        try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
        var externa = MUTA.test(url) && !ehInterno(input, init);
        var p = fetchOriginal.apply(this, arguments);
        if (!externa) return p;
        return p.then(function (res) {
          if (res && res.ok) agendarRefresh();
          return res;
        });
      };
    }

    // alguns apps ainda usam XMLHttpRequest
    var XHR = window.XMLHttpRequest;
    if (XHR && XHR.prototype && XHR.prototype.open) {
      var openOriginal = XHR.prototype.open;
      XHR.prototype.open = function (method, url) {
        try { this.__evCartMuta = MUTA.test(String(url)); } catch (e) { this.__evCartMuta = false; }
        return openOriginal.apply(this, arguments);
      };
      var sendOriginal = XHR.prototype.send;
      XHR.prototype.send = function () {
        var self = this;
        if (self.__evCartMuta) {
          self.addEventListener('load', function () {
            if (self.status >= 200 && self.status < 300) agendarRefresh();
          });
        }
        return sendOriginal.apply(this, arguments);
      };
    }

    // apps que anunciam a mudança por evento, em vez de só chamar a API
    ['cart:refresh', 'cart:updated', 'cart-updated', 'ajaxProduct:added'].forEach(function (ev) {
      document.addEventListener(ev, agendarRefresh);
    });
  }

  /* ---------------------------------------------------------
     2. HEADER — estado de scroll, menu mobile, âncoras
     --------------------------------------------------------- */
  function initHeader() {
    var pending = false;
    function apply() {
      pending = false;
      var scrolled = (window.scrollY || document.documentElement.scrollTop || 0) > 8;
      document.documentElement.toggleAttribute('data-ev-scrolled', scrolled);
    }
    on(window, 'scroll', function () { if (!pending) { pending = true; raf(apply); } }, { passive: true });
    apply();

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-ev-menu-toggle]');
      if (toggle) {
        var menu = $('[data-ev-menu]');
        if (menu) {
          var open = menu.hasAttribute('hidden');
          menu.hidden = !open;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }
      var anchor = e.target.closest && e.target.closest('[data-ev-scroll-to]');
      if (anchor) {
        var id = anchor.getAttribute('data-ev-scroll-to');
        var el = document.getElementById(id);
        if (el) {
          e.preventDefault();
          var y = el.getBoundingClientRect().top + (window.scrollY || 0) - 72;
          window.scrollTo({ top: y, behavior: rm ? 'auto' : 'smooth' });
        }
        var menu2 = $('[data-ev-menu]');
        if (menu2 && !menu2.hidden) menu2.hidden = true;
      }
    });
  }

  /* ---------------------------------------------------------
     3. CARROSSÉIS — swipe, setas, dots, autoplay opcional
     --------------------------------------------------------- */
  function initCarousel(root) {
    if (root.dataset.evBound) return;
    root.dataset.evBound = '1';

    var viewport = $('[data-ev-carousel-viewport]', root);
    var track = $('[data-ev-carousel-track]', root);
    if (!viewport || !track) return;

    var slides = $$('[data-ev-slide]', track);
    var autoplay = Number(root.getAttribute('data-ev-autoplay') || 0);
    var mobileQuery = root.getAttribute('data-ev-mobile-query') || '(max-width: 760px)';
    var index = 0;
    var timer = null;
    var paused = false;
    var pages = 1;
    var step = 100;

    function isMobile() {
      return window.matchMedia && window.matchMedia(mobileQuery).matches;
    }

    // per-view e passo podem diferir entre desktop e mobile, como no preview
    function measure() {
      var pv = Number(root.getAttribute(isMobile() ? 'data-ev-per-view-mobile' : 'data-ev-per-view')) ||
               Number(root.getAttribute('data-ev-per-view')) || 1;
      step = Number(root.getAttribute(isMobile() ? 'data-ev-step-mobile' : 'data-ev-step')) ||
             Number(root.getAttribute('data-ev-step')) || 100;
      pages = Math.max(1, Math.ceil(slides.length / pv));
      if (index > pages - 1) index = pages - 1;
      root.setAttribute('data-ev-pages', pages);
      $$('[data-ev-dot]', root).forEach(function (d, i) { d.hidden = i > pages - 1; });
    }

    function update() {
      track.style.transform = 'translateX(' + (-index * step) + '%)';
      $$('[data-ev-dot]', root).forEach(function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var prev = $('[data-ev-carousel-prev]', root);
      var next = $('[data-ev-carousel-next]', root);
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= pages - 1;
    }

    function go(delta, absolute) {
      if (pages < 2) { index = 0; update(); return; }
      if (absolute) index = delta;
      else index = (index + delta + pages) % pages;
      if (index < 0) index = 0;
      if (index > pages - 1) index = pages - 1;
      update();
    }

    on($('[data-ev-carousel-prev]', root), 'click', function () { go(-1); restart(); });
    on($('[data-ev-carousel-next]', root), 'click', function () { go(1); restart(); });
    $$('[data-ev-dot]', root).forEach(function (d, i) {
      on(d, 'click', function () { go(i, true); restart(); });
    });

    // swipe
    var x0 = null, y0 = null;
    on(viewport, 'touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    on(viewport, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { go(dx < 0 ? 1 : -1); restart(); }
      x0 = y0 = null;
    }, { passive: true });

    function restart() {
      if (!autoplay || rm) return;
      clearInterval(timer);
      timer = setInterval(function () { if (!paused) go(1); }, autoplay);
    }
    if (autoplay && !rm) {
      on(root, 'mouseenter', function () { paused = true; });
      on(root, 'mouseleave', function () { paused = false; });
      restart();
    }

    var rePending = false;
    on(window, 'resize', function () {
      if (rePending) return;
      rePending = true;
      raf(function () { rePending = false; measure(); update(); });
    });

    measure();
    update();
  }

  /* ---------------------------------------------------------
     4. TYPEWRITER
     --------------------------------------------------------- */
  function initTypewriter(el) {
    if (el.dataset.evBound) return;
    el.dataset.evBound = '1';
    var words = (el.getAttribute('data-ev-typewriter') || '').split('|').map(function (w) { return w.trim(); }).filter(Boolean);
    if (!words.length) return;
    var out = $('[data-ev-typewriter-out]', el) || el;
    if (rm) { out.textContent = words[0]; return; }

    var w = 0, c = 0, t = null;
    var SPEED = 65, HOLD = 1700, PAUSE = 350;
    function step() {
      var word = words[w];
      c++;
      out.textContent = word.slice(0, c);
      if (c >= word.length) {
        t = setTimeout(function () {
          w = (w + 1) % words.length; c = 0; out.textContent = '';
          t = setTimeout(step, PAUSE);
        }, HOLD);
      } else {
        t = setTimeout(step, SPEED);
      }
    }
    step();
  }

  /* ---------------------------------------------------------
     5. VÍDEOS de depoimento — play/pause com capa
     --------------------------------------------------------- */
  function initVideo(wrap) {
    if (wrap.dataset.evBound) return;
    wrap.dataset.evBound = '1';
    var video = $('video', wrap);
    var btn = $('[data-ev-video-toggle]', wrap);
    if (!video || !btn) return;

    function setPlaying(playing) {
      wrap.setAttribute('data-playing', playing ? 'true' : 'false');
      btn.setAttribute('aria-label', playing ? 'Pausar vídeo' : 'Reproduzir vídeo');
    }
    on(btn, 'click', function () {
      if (video.paused) {
        $$('[data-ev-video] video').forEach(function (v) { if (v !== video && !v.paused) v.pause(); });
        video.play();
        setPlaying(true);
      } else {
        video.pause();
        setPlaying(false);
      }
    });
    on(video, 'ended', function () { setPlaying(false); });
    on(video, 'pause', function () { setPlaying(false); });
    setPlaying(false);
  }

  /* ---------------------------------------------------------
     6. PARALLAX das frutas (amplitude por elemento)
     Os listeners de scroll/resize são globais (não há uma "raiz" por
     seção para guardar um dataset flag) — por isso o bind fica numa
     flag de módulo e só acontece uma vez. `apply()` sempre reconsulta
     `[data-ev-parallax]` na hora, então seções novas renderizadas
     depois (shopify:section:load) entram na animação sem precisar de
     um novo listener.
     --------------------------------------------------------- */
  var fruitParallaxBound = false;
  function fruitParallaxApply() {
    var els = $$('[data-ev-parallax]');
    if (!els.length) return;
    var vh = window.innerHeight || 1;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var progress = 1 - 2 * ((r.top + r.height / 2) / vh);
      var amp = Number(el.getAttribute('data-ev-parallax')) || 100;
      el.style.transform = 'translateY(' + (-progress * amp).toFixed(1) + 'px)';
    });
  }
  var fruitParallaxPending = false;
  function fruitParallaxOnScroll() {
    if (fruitParallaxPending) return;
    fruitParallaxPending = true;
    raf(function () { fruitParallaxPending = false; fruitParallaxApply(); });
  }
  function initFruitParallax() {
    if (rm) return;
    var els = $$('[data-ev-parallax]');
    if (!els.length) return;
    if (!fruitParallaxBound) {
      fruitParallaxBound = true;
      on(window, 'scroll', fruitParallaxOnScroll, { passive: true });
      on(window, 'resize', fruitParallaxOnScroll);
    }
    fruitParallaxApply();
  }

  /* ---------------------------------------------------------
     7. FAIXA DE PROVAS
     Zoom no hover foi removido a pedido — ícones ficam com
     tamanho fixo em todos os estados. O marquee (CSS puro,
     ev-provas keyframe) continua rodando sem JS nenhum aqui.
     --------------------------------------------------------- */

  /* ---------------------------------------------------------
     8. REVEAL on scroll

     Um único IntersectionObserver vive por toda a página, em vez de um
     novo a cada chamada. Isso importa porque agora existe conteúdo que
     nasce DEPOIS do boot: a troca de sabor da PDP substitui o innerHTML
     da seção "quem provou, avaliou" pelo HTML do sabor de destino, e
     esse HTML vem com .ev-reveal e sem .is-in.

     Como o observer era criado no boot e só conhecia os elementos que
     existiam naquele instante, tudo que entrasse depois ficava preso em
     opacity 0 — presente no DOM, invisível na tela. Era exatamente isso
     que fazia as avaliações "sumirem" ao trocar de sabor (a tabela
     nutricional escapava porque lá o .ev-reveal é o wrapper, que não é
     substituído — só o miolo do card é).

     initReveal aceita um escopo e pode ser chamado quantas vezes for
     preciso: o seletor :not(.is-in) e o unobserve garantem idempotência.
     Reobservar (em vez de forçar .is-in) preserva a animação de entrada:
     imediata se o trecho já está visível, no scroll se ainda está abaixo
     da dobra.
     --------------------------------------------------------- */
  var revealIO = null;
  function revealObserver() {
    if (revealIO) return revealIO;
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealIO.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    return revealIO;
  }

  function initReveal(scope) {
    var els = $$('.ev-reveal:not(.is-in)', scope);
    if (!els.length) return;
    if (rm || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = revealObserver();
    els.forEach(function (el) { io.observe(el); });
  }

  /* Rede de segurança do reveal: qualquer HTML injetado por JS (troca de
     sabor, drawer do carrinho, app de terceiro) passa a ser observado
     sozinho, sem quem injetou precisar avisar. Só olha childList, e o
     trabalho real fica num raf com trava — então uma sequência de trocas
     rápidas gera um scan por frame, e não um por mutação. Marcar .is-in
     é mudança de atributo, que este observer não escuta: não há laço. */
  function initRevealWatcher() {
    if (window.__evRevealWatch || !('MutationObserver' in window) || !document.body) return;
    window.__evRevealWatch = true;
    var pendente = false;
    new MutationObserver(function (muts) {
      if (pendente) return;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          pendente = true;
          raf(function () { pendente = false; initReveal(); });
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------
     9. FAQ acordeão
     --------------------------------------------------------- */
  function initFaq(root) {
    if (root.dataset.evBound) return;
    root.dataset.evBound = '1';
    $$('[data-ev-faq-q]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var item = btn.closest('[data-ev-faq-item]');
        var open = item.getAttribute('data-open') === 'true';
        $$('[data-ev-faq-item]', root).forEach(function (i) {
          i.setAttribute('data-open', 'false');
          var b = $('[data-ev-faq-q]', i);
          if (b) b.setAttribute('aria-expanded', 'false');
          var a = $('[data-ev-faq-a]', i);
          if (a) a.hidden = true;
        });
        if (!open) {
          item.setAttribute('data-open', 'true');
          btn.setAttribute('aria-expanded', 'true');
          var ans = $('[data-ev-faq-a]', item);
          if (ans) ans.hidden = false;
        }
      });
    });
  }

  /* ---------------------------------------------------------
     10. POPUP de newsletter

     Os limiares (scroll, tempo, exit-intent) vêm da seção, que já os
     escolhe conforme o tipo de página. Aqui ficam só as travas que
     dependem do navegador:
       · 1x por sessão              — sessionStorage
       · fechou: some por N dias    — localStorage com timestamp
       · cadastrou: some pra sempre — localStorage
       · item no carrinho           — confere /cart.js na hora de abrir,
                                      porque o carrinho pode ter mudado
                                      depois que a página foi renderizada
     Cliente logado e carrinho cheio no carregamento já são barrados na
     seção, que nem renderiza o markup.
     --------------------------------------------------------- */
  function initPopup(popup) {
    if (popup.dataset.evBound) return;
    popup.dataset.evBound = '1';

    var design = !!(window.Shopify && window.Shopify.designMode);
    var SEEN_KEY = 'evida_popup_seen';
    var DISMISS_KEY = 'evida_popup_dismissed_until';
    var SUB_KEY = 'evida_popup_subscribed';

    function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

    // o form de cliente do Shopify volta com ?customer_posted=true — vale
    // para o popup e para o form do rodapé: quem assinou não vê mais
    if (location.search.indexOf('customer_posted=true') !== -1) lsSet(SUB_KEY, '1');

    var blocked = false;
    if (!design) {
      if (lsGet(SUB_KEY) === '1') blocked = true;
      var until = parseInt(lsGet(DISMISS_KEY) || '0', 10);
      if (until && Date.now() < until) blocked = true;
      try { if (sessionStorage.getItem(SEEN_KEY) === '1') blocked = true; } catch (e) {}
    }

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
    var delay = Number(popup.getAttribute(isMobile ? 'data-ev-popup-delay-mobile' : 'data-ev-popup-delay-desktop') || 0);
    var ratio = Number(popup.getAttribute(isMobile ? 'data-ev-popup-scroll-mobile' : 'data-ev-popup-scroll-desktop') || 0.4);
    var exitOn = popup.getAttribute('data-ev-popup-exit') === 'true';
    var days = Number(popup.getAttribute('data-ev-popup-suppress-days') || 14);
    var timer = null;

    function close() {
      popup.removeAttribute('data-open');
      setTimeout(function () { popup.hidden = true; }, 300);
      document.body.style.overflow = '';
      lsSet(DISMISS_KEY, String(Date.now() + days * 86400000));
    }
    function show() {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExit);
      popup.hidden = false;
      raf(function () { popup.setAttribute('data-open', 'true'); });
    }
    function markSeen() {
      try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    }
    // disparo automático: uma vez por sessão, e só com carrinho vazio
    function fire() {
      if (blocked || popup.hidden === false) return;
      blocked = true;
      if (design) { show(); return; }
      fetch(Cart.routes().get, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c && c.item_count) return;
          markSeen();
          show();
        })
        .catch(function () { markSeen(); show(); });
    }
    function onScroll() {
      var doc = document.documentElement;
      var h = doc.scrollHeight - window.innerHeight;
      var sc = window.scrollY || doc.scrollTop || 0;
      if (h > 0 && sc / h >= ratio) fire();
    }
    // exit-intent: cursor saindo pelo topo da janela (só desktop)
    function onExit(e) {
      if (e.clientY <= 0 && !e.relatedTarget) fire();
    }

    // disparo manual (botões com data-ev-popup-open): sempre abre
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ev-popup-open]')) {
        e.preventDefault();
        show();
      }
    });

    if (!blocked) {
      if (delay > 0) timer = setTimeout(fire, delay);
      on(window, 'scroll', onScroll, { passive: true });
      if (exitOn && !isMobile) on(document, 'mouseout', onExit);
    }

    $$('[data-ev-popup-close]', popup).forEach(function (b) { on(b, 'click', close); });
    on(popup, 'click', function (e) { if (e.target === popup) close(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
  }

  /* ---------------------------------------------------------
     11. Newsletter inline (Shopify customer form já faz POST;
         aqui só o estado visual de "enviado" quando aplicável)
     --------------------------------------------------------- */
  function initSeloSpin() { /* puramente CSS — mantido por clareza */ }

  /* ---------------------------------------------------------
     12. MEGA FUNDO COMPARTILHADO (comparativo + depoimentos em vídeo)
     No preview original as duas seções ficavam dentro de um único
     wrapper com um fundo só. No Shopify cada seção é independente, então
     um elemento (marcado com [data-ev-megabg], hoje só em
     evida-comparativo.liquid) é esticado via JS para cobrir da própria
     seção até a base da seção indicada em [data-ev-megabg-end] — assim o
     gradiente/textura/frutas aparecem como um fundo contínuo por trás das
     duas seções, sem linha de emenda nem gap de fundo entre elas.
     --------------------------------------------------------- */
  var sharedBgBound = false;
  var sharedBgPending = false;
  function sharedBgMeasureOne(bg) {
    var startSection = bg.closest('section');
    var endId = bg.getAttribute('data-ev-megabg-end');
    var endEl = endId && document.getElementById(endId);
    if (!startSection || !endEl) return;
    var startTop = startSection.getBoundingClientRect().top;
    var endBottom = endEl.getBoundingClientRect().bottom;
    var height = endBottom - startTop;
    if (height > 0) bg.style.height = height + 'px';
  }
  function sharedBgMeasureAll() {
    $$('[data-ev-megabg]').forEach(sharedBgMeasureOne);
  }
  function sharedBgOnResize() {
    if (sharedBgPending) return;
    sharedBgPending = true;
    raf(function () { sharedBgPending = false; sharedBgMeasureAll(); });
  }
  function initSharedBg() {
    var bgs = $$('[data-ev-megabg]');
    if (!bgs.length) return;

    // os listeners de window são globais e só precisam ser ligados uma
    // vez; measureAll() reconsulta [data-ev-megabg] a cada chamada, então
    // uma seção recarregada pelo editor não duplica scroll/resize handlers.
    if (!sharedBgBound) {
      sharedBgBound = true;
      on(window, 'resize', sharedBgOnResize);
      on(window, 'orientationchange', sharedBgOnResize);
      on(window, 'load', sharedBgMeasureAll);
    }
    sharedBgMeasureAll();
    // re-mede enquanto imagens/webfonts ainda estão carregando e podem
    // alterar a altura das seções (o vídeo/tabela mudam de altura).
    setTimeout(sharedBgMeasureAll, 250);
    setTimeout(sharedBgMeasureAll, 800);
    setTimeout(sharedBgMeasureAll, 2000);
  }

  /* ---------------------------------------------------------
     Boot
     --------------------------------------------------------- */
  function boot(scope) {
    var root = scope || document;
    $$('[data-ev-carousel]', root).forEach(initCarousel);
    $$('[data-ev-typewriter]', root).forEach(initTypewriter);
    $$('[data-ev-video]', root).forEach(initVideo);
    $$('[data-ev-faq]', root).forEach(initFaq);
    $$('[data-ev-popup]', root).forEach(initPopup);
    initReveal(root);
    initFruitParallax();
    initSharedBg();
  }

  function start() {
    Cart.init();
    initCartSync();
    initHeader();
    initSeloSpin();
    boot(document);
    initRevealWatcher();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* ---------------------------------------------------------
     API pública mínima

     Quem injeta HTML por conta própria pode pedir o reprocessamento do
     trecho explicitamente, em vez de depender do watcher acima:
     Evida.boot(escopo) refaz tudo (reveal, carrossel, FAQ, popup) e
     Evida.reveal(escopo) resolve só a animação de entrada.
     --------------------------------------------------------- */
  window.Evida = window.Evida || {};
  window.Evida.boot = boot;
  window.Evida.reveal = initReveal;

  // Editor de temas: re-inicializa a seção recarregada
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
